import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboards-ves export-page" }
const _hoisted_2 = { class: "dashboards-ves__controls" }
const _hoisted_3 = { class: "container-page big dashboards-ves__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsYearFilterBlock = _resolveComponent("DashboardsYearFilterBlock")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_DashboardsCards = _resolveComponent("DashboardsCards")!
  const _component_DashboardsMapBlock = _resolveComponent("DashboardsMapBlock")!
  const _component_DashboardsChart = _resolveComponent("DashboardsChart")!
  const _component_DashboardsChartsBlock = _resolveComponent("DashboardsChartsBlock")!
  const _component_DashboardsTables = _resolveComponent("DashboardsTables")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: "Обзор внешнеэкономических связей субъектов РФ",
      dense: ""
    }, {
      button: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DashboardsYearFilterBlock, {
            onChangeFilter: _ctx.changeFilter,
            class: "dashboards-ves__filter",
            filter: _ctx.filter
          }, null, 8, ["onChangeFilter", "filter"]),
          _createVNode(_component_ExportButtons, {
            loading: _ctx.isExportProgress,
            onExportPdf: _ctx.downloadPDF,
            onExportPptx: _ctx.downloadPptx,
            exportTypes: ['pptx', 'pdf']
          }, null, 8, ["loading", "onExportPdf", "onExportPptx"])
        ])
      ]),
      subtitles: _withCtx(() => [
        _createVNode(_component_DateActualDataSubtitle, {
          class: "dashboards-ves__subtitle",
          filter: _ctx.filter,
          isSimpleYearLabel: ""
        }, null, 8, ["filter"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DashboardsCards, { filter: _ctx.filter }, null, 8, ["filter"]),
      _createVNode(_component_DashboardsMapBlock, {
        filter: _ctx.filter,
        isSimpleYearLabel: ""
      }, null, 8, ["filter"]),
      _createVNode(_component_DashboardsChartsBlock, {
        filter: _ctx.filter,
        calendarParams: _ctx.calendarParams,
        isChartVisible: _ctx.isChartVisible
      }, {
        chart: _withCtx(() => [
          _createVNode(_component_DashboardsChart, {
            filter: _ctx.filter,
            title: "Топ-5 стран-партнеров по количеству мероприятий субъектов РФ в сфере ВЭД",
            isBarClickable: "",
            isSimpleYearLabel: ""
          }, null, 8, ["filter"])
        ]),
        _: 1
      }, 8, ["filter", "calendarParams", "isChartVisible"]),
      _createVNode(_component_DashboardsTables, {
        editable: "",
        isDatesColumnFirst: "",
        class: "dashboards-ves__tables",
        onChangePlannedEventsFilter: _ctx.changePlannedEventsFilter
      }, null, 8, ["onChangePlannedEventsFilter"])
    ])
  ]))
}